import { Helper } from "../util/helper.js";
import { FAIcon } from "./faIcon.js";
import React from "react";
export default class ExtendedViewButton extends React.Component<{
    isExtended: boolean;
    onClick: (isExtended: boolean) => void;
    visible?: boolean;
    wrapperStyle?: React.CSSProperties;
    wrapperClass?: string;
}, any>{
    constructor(props) {
        super(props);
    }

    private onClick = (e) => {
        this.props.onClick(!this.props.isExtended);
    }

    render() {
        if (Helper.hasValue(this.props.visible) && !this.props.visible)
            return null;

        let icon = this.props.isExtended ? "caret-up" : "caret-down";
        let text = this.props.isExtended ? Helper.getTranslation("WebSMS.GeneralSettings.Units.ShowLess") : Helper.getTranslation("WebSMS.GeneralSettings.Units.ShowMore");

        return <div className={this.props.wrapperClass} style={this.props.wrapperStyle}>
            <div className="extended-view-container" onClick={this.onClick}>
                <FAIcon name={icon} sameWidth={true} />
                <label>{text}</label>
            </div>
        </div>
    }
}